module.exports = __webpack_public_path__ + "img/mapa-leyenda.2d00e6d5.png";